module.exports = __webpack_public_path__ + "static/media/ARVEK.dfc8871d.png";